
export enum BuildingLogicalType {
    PHYSICAL_SITE = 1,
    GEOGRAPHICAL_REGION = 2,
    NON_PHYSICAL_GROUPING = 3,
}
